<template>
  <v-menu
    origin="top right"
    :close-on-content-click="false"
    v-model="menu"
    :nudge-right="40"
    lazy transition="scale-transition"
    offset-y
    :disabled="readonly || disabled"
    full-width
    content-class="elevation-0"
  >
    <v-text-field
      slot="activator"
      v-model="dateFormated"
      :label="label"
      prepend-icon="event"
      mask="##/##/####"
      :validate-on-blur="true"
      @blur="parseDate()"
      :readonly="readonly"
      :disabled="readonly || disabled"
      :rules="reglas()"
      :hide-details="hideDetails"
      ref="textfield"
    />
    <v-layout row>
    <v-date-picker 
      no-title 
      first-day-of-week="1" 
      locale="es-es" 
      :width="width"
      ref="picker"
      v-model="date"
      :max="Number.isInteger(extraYearsMax) ? fechaInicio : null"
      :disabled="readonly || disabled"
      @input="menu = false"
      :hide-details="hideDetails"
    >
    </v-date-picker>
    <v-spacer @click="menu = false"/>
    </v-layout>
  </v-menu>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    value: {
      type: String
    },
    width: {
      type: String
    },
    obligatorio: {
      default: false
    },
    extraYearsMax: {
      default: null
    },
    nacimiento: {
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    hideDetails: {
      type: Boolean,
      default: false
    },
    anteriorAHoy: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.updateFormatted(this.value)
  },
  data () {
    return {
      dateFormated: null,
      menu: false
    }
  },
  computed: {
    date: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    fechaInicio () {
      return Number.isInteger(this.extraYearsMax) ? moment().format('YYYY-MM-DD') : moment().subtract(this.extraYearsMax, 'years').format('YYYY-MM-DD')
    }
  },
  methods: {
    reglas () {
      if (!this.obligatorio || this.menu) {
        return []
      } else {
        return [!!this.value || this.$t('general.misc.fechaObligatoria')]
      }
    },
    parseDate () {
      if (!this.dateFormated) {
        return
      }
      if (moment(this.dateFormated, 'DDMMYYYY').isValid()) {
        this.$emit('input', moment(this.dateFormated, 'DDMMYYYY').format('YYYY-MM-DD'))
      } else {
        this.$emit('input', null)
      }
    },
    updateFormatted (newVal) {
      this.dateFormated = moment(newVal, 'YYYY-MM-DD').format('DDMMYYYY')
    },
    allowedDates (val) {
      return moment(val).isBefore(moment().subtract(18, 'years'))
    }
  },
  watch: {
    value (newVal) {
      this.updateFormatted(newVal)
    },
    menu (val) {
      if (this.nacimiento) {
        val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
      }
      if (!val) {
        this.$refs.textfield.focus()
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/generic/ODatePicker.vue